<script setup lang="ts">
defineProps<{ title: string }>();
</script>

<template>
  <div class="bg-info-doux flex flex-col gap-1 rounded-[24px] p-4">
    <p class="text-[14px] leading-[1.4] font-semibold">{{ title }}</p>
    <p class="text-encre-douce text-[12px] leading-[1.45]"><slot /></p>
  </div>
</template>
